<script>
import { mapState, mapMutations } from "vuex";
import { get } from "lodash";
import LecturesMenu from "./LecturesMenu";
import config from "@/config/config";
import IsMobile from "@/service/IsMobile";
import Hls from "hls.js";

export default {
  name: "ComponentsCourseVideo",
  components: {
    LecturesMenu,
  },
  data() {
    return {
      playerVars: {
        // https://developers.google.com/youtube/player_parameters
        autoplay: 0,
        controls: 1,
        rel: 0,
        showinfo: 0,
        iv_load_policy: 3,
        cc_load_policy: 0,
        cc_lang_pref: "en",
        wmode: "transparent",
        modestbranding: 1,
        disablekb: 1,
        origin: "https://wszystkozaczynasiewglowie.pl",
        enablejsapi: 1,
        widgetid: 1,
      },
    };
  },
  computed: {
    ...mapState(config.app, ["course", "currentLectureIndex"]),
    lectures() {
      return get(this, "course.lectures", []);
    },
    lecture() {
      return !this.lectures[this.currentLectureIndex]
        ? {}
        : this.lectures[this.currentLectureIndex];
    },
    material() {
      return get(this, "lecture.material", {});
    },
    video() {
      return get(this, "lecture.video", {});
    },
    videoFile() {
      const desktopVideo = get(this, "lecture.video.video.stream");
      const mobileVideo = get(this, "lecture.video.mobile.url");
      if (IsMobile() && mobileVideo && !this.forceDesktop) {
        return mobileVideo;
      }
      return desktopVideo;
    },
    isMobile() {
      return IsMobile();
    },
    isLast() {
      return this.currentLectureIndex >= this.lectures.length - 1;
    },
    hasExam() {
      return this.course.exam && this.course.exam.id;
    },
    finalWords() {
      return get(this, "course.finalWords", null);
    },
    flow() {
      return config.initial.course;
    },
  },
  methods: {
    ...mapMutations(config.app, [
      "setCurrentCourse",
      "setCurrentLectureIndex",
      "setCurrent",
    ]),
    next() {
      // if (this.lectures[this.currentLectureIndex] && this.lectures[this.currentLectureIndex].material) {
      //   this.setCurrentCourse(this.flow.materials);
      //   return;
      // }

      const nextIndex = this.currentLectureIndex + 1;

      if (this.lectures[nextIndex] && this.lectures[nextIndex].video) {
        this.setCurrentCourse(this.flow.video);
        this.setCurrentLectureIndex(nextIndex);

        let stream = get(this, "lecture.video.video.stream");
        let video = this.$refs["video"];

        if (Hls.isSupported()) {
          let hls = new Hls();
          hls.loadSource(stream);
          hls.attachMedia(video);
          hls.on(Hls.Events.MANIFEST_PARSED, function () {
            video.play();
          });
        } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
          video.src = stream;
        }
        return;
      }

      // if (this.lectures[nextIndex] && this.lectures[nextIndex].material) {
      //   this.setCurrentCourse(this.flow.materials);
      //   this.setCurrentLectureIndex(nextIndex);
      //   return;
      // }

      if (this.isLast) {
        this.setCurrentCourse(this.flow.finish);
        return;
      }

      this.setCurrentCourse(this.flow.video);
      this.setCurrentLectureIndex(0);
    },
    getVideoId() {
      const { video } = this;
      if (!video.videoUrl) {
        return null;
      }
      return this.$youtube.getIdFromUrl(video.videoUrl);
    },
    changeVideo() {
      let stream = get(this, "lecture.video.video.stream");
      let video = this.$refs["video"];

      if (Hls.isSupported()) {
        let hls = new Hls();
        hls.loadSource(stream);
        hls.attachMedia(video);
        hls.on(Hls.Events.MANIFEST_PARSED, function () {
          video.play();
        });
      } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
        video.src = stream;
      }
    },
  },
  mounted() {
    let stream = get(this, "lecture.video.video.stream");
    let video = this.$refs["video"];

    if (Hls.isSupported()) {
      let hls = new Hls();
      hls.loadSource(stream);
      hls.attachMedia(video);
      hls.on(Hls.Events.MANIFEST_PARSED, function () {
        video.play();
      });
    } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = stream;
    }
  },
};
</script>
<style lang="scss" scoped>
video {
  max-width: 100%;
}
#addition-material {
  font-size: 1rem;
}

@media screen and (min-width: 576px) {
  video {
    height: 287px;
  }
}

@media screen and (min-width: 768px) {
  video {
    height: 388px;
  }
}

@media screen and (min-width: 992px) {
  video {
    height: 343px;
  }
}

@media screen and (min-width: 992px) {
  video {
    height: 411px;
  }
}
</style>
<template>
  <div id="course-video">
    <LecturesMenu />
    <div class="wrapper">
      <!-- <button class="btn w-auto" @click="setCurrentCourse(flow.lecture)">
        powrót
      </button> -->
      <div v-html="video.content" class="mt-5 mb-5" />
      <video width="100%" ref="video" controls></video>
      <div v-html="material.content" class="mt-5 mb-5" />
      <div
        v-if="lecture.material.files.length > 0"
        id="addition-material"
        class="d-flex"
      >
        <span class="font-weight-bold mr-3">Pobierz materiał:</span>
        <ul v-if="material.files">
          <li v-for="(file, index) in material.files" :key="index">
            <a :href="file.url" target="_blank">
              {{ file.name }}
            </a>
          </li>
        </ul>
      </div>
      <button
        v-if="isLast && hasExam"
        class="btn w-auto mt-5"
        @click="setCurrent('exam')"
      >
        Przejdź do egzaminu
      </button>
      <button v-else-if="!isLast" class="btn w-auto mt-5" @click="next()">
        Przejdź do następnej części
      </button>
    </div>
  </div>
</template>
